module.exports = __webpack_public_path__ + "img/door-closed-icon-shadow.58965771.svg";